var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.modalShow
    ? _c("div", { staticClass: "h-vertical-align-container" }, [
        _c("div", { staticClass: "modal__overlay" }),
        _c(
          "div",
          { staticClass: "modal__wrapper modal__wrapper--marketingConsent" },
          [
            _c(
              "form",
              {
                staticClass: "modal__marketingconsent",
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    _vm.updateUser__invoke(_vm.updatedProfile)
                  }
                }
              },
              [
                _c("h1", [_vm._v("Marketing Consent")]),
                _vm._m(0),
                _c(
                  "button",
                  {
                    staticClass: "btn btn--purpleLight",
                    attrs: { type: "submit" },
                    on: {
                      click: function($event) {
                        _vm.updatedProfile.marketing_consent = true
                      }
                    },
                    model: {
                      value: _vm.updatedProfile.marketing_consent,
                      callback: function($$v) {
                        _vm.$set(_vm.updatedProfile, "marketing_consent", $$v)
                      },
                      expression: "updatedProfile.marketing_consent"
                    }
                  },
                  [_vm._v("Yes")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn btn--white",
                    attrs: { type: "submit" },
                    on: {
                      click: function($event) {
                        _vm.updatedProfile.marketing_consent = false
                      }
                    },
                    model: {
                      value: _vm.updatedProfile.marketing_consent,
                      callback: function($$v) {
                        _vm.$set(_vm.updatedProfile, "marketing_consent", $$v)
                      },
                      expression: "updatedProfile.marketing_consent"
                    }
                  },
                  [_vm._v("No")]
                )
              ]
            )
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "marketingConsent--container" }, [
      _c("p", [
        _vm._v(
          "Flixel can send me product updates and offers via email. You can opt-out at any time."
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f99f5578", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f99f5578","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MarketingConsent.vue
// module id = null
// module chunks = 